import { useContext } from 'react'
import { AppRatingContext } from '../provider'
import { AppRatingContextProps } from '../provider/app-rating.context'

/**
 * A custom hook to provide methods and values from AppRatingContext
 */
const useAppRatingContext = (): AppRatingContextProps => {
  const context = useContext(AppRatingContext)
  if (!context) throw new Error('useRating must be used within AppRatingProvider')
  return context
}

export default useAppRatingContext
